import { render, staticRenderFns } from "./PagingObserver.vue?vue&type=template&id=64d7df62&"
import script from "./PagingObserver.vue?vue&type=script&lang=js&"
export * from "./PagingObserver.vue?vue&type=script&lang=js&"
import style0 from "./PagingObserver.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports